module.exports = __webpack_public_path__ + "static/img/areaA-28.ffeaafb.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-28.png
// module id = 940
// module chunks = 1